import type { HomeTab } from "./homeBrowserTypes";

export interface HomeEmptyCopy {
  title: string;
  hint?: string;
}

/**
 * Two-line empty state per tab (house convention). `scoped` swaps the org-wide
 * hints for workspace-scoped ones — on a workspace page "Files you create or
 * upload appear here" reads as a claim about the whole account.
 */
export function homeEmptyCopy(tab: HomeTab, scoped = false): HomeEmptyCopy {
  switch (tab) {
    case "all":
      return {
        title: "Nothing here yet",
        hint: scoped
          ? "Files, canvases, and chats in this workspace appear here"
          : "Files, canvases, and chats you work on appear here",
      };
    case "recents":
      return {
        title: "No files yet",
        hint: scoped
          ? "Drop a file anywhere on this page to upload it here"
          : "Files you create or upload appear here",
      };
    case "canvases":
      return {
        title: "No canvases yet",
        hint: "Create a canvas from the box above or + New",
      };
    case "chats":
      return {
        title: "No chats yet",
        hint: "Start a conversation from the box above",
      };
    case "starred":
      return {
        title: "Nothing starred yet",
        hint: scoped
          ? "Star a canvas, file, or chat in this workspace and it stays here"
          : "Star a canvas, file, skill, or chat and it stays here",
      };
  }
}
